var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { useFeatureFlagsContext } from '#context';
import { areExperimentalFeaturesEnabled, isEnabledFromFeatureFlag, } from '#services';
export const FeatureFlag = ({ children, flagKey = '', flagName, flagValue = '', }) => {
    _react_refresh_temp_2();
    const { isError: isAmplitudeError, variants } = useFeatureFlagsContext();
    if (isAmplitudeError) {
        /**
         * Fallback to experimental feature flag
         * to enable local development where
         * there is no Amplitude engaged:
         */
        return areExperimentalFeaturesEnabled() ? children : null;
    }
    return isEnabledFromFeatureFlag({ flagKey, flagName, flagValue, variants })
        ? children
        : null;
};
_react_refresh_temp_1 = FeatureFlag;
$RefreshReg$(_react_refresh_temp_1, "FeatureFlag");
_react_refresh_temp_2(FeatureFlag, "xxNiWH4NKepHka/b8d/D5lsivRo=", false, () => [useFeatureFlagsContext]);
